import { combineReducers } from 'redux';
import activeButton from './activeButton';
import creatorType from './creatorType';
import displayCreator from './displayCreator';
import imageUrls from './imageUrls';
import lastUsedImageType from './lastUsedImageType';
import lastUsedImageUrl from './lastUsedImageUrl';
import signExpanded from './signExpanded';

const SignatureReducer = (state, action) => combineReducers({
  activeButton,
  creatorType,
  displayCreator,
  imageUrls,
  lastUsedImageType,
  lastUsedImageUrl,
  signExpanded,
})(state, { ...action, state });

export default SignatureReducer;



// WEBPACK FOOTER //
// ./src-react/SignatureManager/SignatureReducer/index.jsx